var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("span", { staticClass: "stanley-typing-text" }, [
      _vm._v(_vm._s(_vm.typedText))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }